import React, { useState, useCallback, useEffect } from "react";
import http from "../../utils/http-common";
import {ArrowBackIosNewRounded as ArrowBackIosNewRoundedIcon, FileUploadOutlined as FileUploadOutlinedIcon, KeyboardArrowDown, KeyboardArrowRight, KeyboardArrowUp} from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "../../assets/landing_page/new/closeicon.svg";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import Saved from '../../assets/planshare icons/download.png';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton, Tabs, Tab, Paper, Typography, Modal, Select, MenuItem, TextField, Box,
} from "@mui/material";
import { Button } from "react-scroll";
import { handleDownloadPDF } from "../../Layouts/pdf/healthcareReport";

// Column header icons
const columnHeaders = [
  // { icon: require("../../assets/landing_page/Images/Metric.png"), label: "Metric" },
  // { icon: require("../../assets/landing_page/Images/Task ID.png"), label: "Task ID" },
  { icon: require("../../assets/landing_page/Images/Task Name.png"), label: "Task Name" },
  { icon: require("../../assets/landing_page/Images/Duration.png"), label: "Duration" },
  { icon: require("../../assets/landing_page/Images/Date.png"), label: "Start Date" },
  { icon: require("../../assets/landing_page/Images/Date.png"), label: "End Date" },
 /*  { icon: require("../../assets/landing_page/Images/Resource.png"), label: "Resource" }, */
  { icon: require("../../assets/planshare icons/Report Description.png"), label: "Report Description" },
];

function AnalysisReport(props) {
  const location = useLocation();
  const selectedPlanId = location.state?.id
  const searchParams = new URLSearchParams(location.search);
  const styles = {
    tableCell: {
      borderRight: "1px solid #E0E0E0",
    },
    tableHead: {
      backgroundColor: "#FAFAFA",
    },
  };
  const [totalTest, setTotalTest] = useState(0);
  const [totalTask, setTotalTask] = useState(0);
  const [failedTask, setFailedTask] = useState(0);
  const [passedData, setPassedData] = useState([]);
  const [failedData, setFailedData] = useState([]);
  const [error, setError] = useState(null);

  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    if (selectedPlanId) {
      fetchReportData(selectedPlanId);
    }
  }, [selectedPlanId]);

  const fetchReportData = async (planId) => { 
    setLoading(true);
    setError(null);

    try {
      const response = await http.get(`master_service/plan/validation/rules/report?plan_id=${planId}`);
      if (response.data) {
        const responseData = response.data.test_done;
        const responseTotalTask = response.data.total_task;
        const responseFailedTask = response.data.faild_report_count;
        let failedArray = [];

        if (response.data.failed_report) {
          Object.values(response.data.failed_report).forEach((rule) => {
            if (rule.details && Array.isArray(rule.details)) {
              rule.details.forEach((detail) => {
                const tasks = detail.plan_datas?.data?.tasks || [];

                tasks.forEach((task) => {
                  failedArray.push({
                    ruleName: rule.rule_name || "",
                    description: detail.description || "",
                    planDataId: detail.plan_data_id || "",
                    taskId: task.id !== undefined ? String(task.id) : "",
                    taskName: task.text || "",
                    startDate: formatDate(task.start_date),
                    endDate: formatDate(task.end_date),
                    duration: task.duration || "",
                    resource: task["Resource Names"] || "",
                  });
                });
              });
            }
          });
        }

        let passedArray = [];

        if (Array.isArray(response.data.passed_record)) {
          response.data.passed_record.forEach((record) => {
            const tasks = record.plan_datas?.data?.tasks || [];

            tasks.forEach((task) => {
              passedArray.push({
                ruleName: record.rule_name || "",
                planDataId: record.plan_data_id || "",
                description: record.success_task_details || "",
                taskId: task.id !== undefined ? String(task.id) : "",
                taskName: task.text || "",
                startDate: formatDate(task.start_date),
                endDate: formatDate(task.end_date),
                duration: task.duration || "",
                resource: task["Resource Names"] || "",
              });
            });
          });
        }
        // Function to format dates to DD-MM-YYYY
        function formatDate(dateString) {
          if (!dateString) return "";
          const date = new Date(dateString);
          if (isNaN(date.getTime())) return "";
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }

        setPassedData(passedArray || []);
        setFailedData(failedArray || []);
        setTotalTest(responseData);
        setTotalTask(responseTotalTask);
        setFailedTask(responseFailedTask);
      } else {
        setError("Failed to fetch report data");
      }
    } catch (err) {
      console.error("Error fetching report data:", err);
      setError("An error occurred while fetching data.");
    }
    setLoading(false);
};

  const [isPassedExpanded, setIsPassedExpanded] = useState(true);
  const [isFailedExpanded, setIsFailedExpanded] = useState(true);

  const handleTogglePassed = () => {
    setIsPassedExpanded((prev) => !prev);
  };

  const handleToggleFailed = () => {
    setIsFailedExpanded((prev) => !prev);
  };

  const navigate = useNavigate();

  const [planData, setPlanData] = useState([]);
  const handleNavigate = (path) => () => {
    navigate(path);
  };


  const handleDownloadReport = () => {
    const headers = ["S.No", "Metric", "Task ID", "Task Name", "Duration", "Start Date", "End Date", /* "Resource",  */"Report Description"];

    const convertToCSV = (data) => {
      const escapeCSVValue = (value) => {
        const strValue = value !== null && value !== undefined ? String(value) : ""; // Ensure value is a string
        return strValue.includes(",") ? `"${strValue}"` : strValue; // Wrap values with commas in quotes
      };
    
      const rows = data.map((row, index) =>
        [
          index + 1,
          escapeCSVValue(row.ruleName),  // Fixing comma issue
          escapeCSVValue(row.taskId),
          escapeCSVValue(row.taskName),
          escapeCSVValue(row.duration),
          escapeCSVValue(row.startDate),
          escapeCSVValue(row.endDate),
          escapeCSVValue(row.description)
        ].join(",") // Ensure all fields are correctly escaped
      );
    
      return [headers.join(","), ...rows].join("\n");
    };

    const passedCSV = convertToCSV(passedData);
    const failedCSV = convertToCSV(failedData);

    const csvContent = "data:text/csv;charset=utf-8," +
      "Passed Data\n" + passedCSV + "\n\nFailed Data\n" + failedCSV;

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    const passlength = passedData.length
    const failLength = failedData.length
    handleDownloadPDF(planName, customerName, planDescription, passlength, passedData, failLength, failedData,);
  };

  const [open1, setOpen1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const [uploadedFile, setUploadedFile] = useState("");
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setUploadedFileName(acceptedFiles[0].name);
      setUploadedFile(acceptedFiles[0]);
    } else {
      toast.error(
        <>
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
            }}>
            Plan Upload Unsuccessfull
          </div>
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "22px",
              textAlign: "left",
            }}>
            Something went wrong. Please check your file and try uploading again
          </div>
        </>
      );
    }
  }, []);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const handleOpen = () => {
    setOpen1(true);
  };
  const handleClose = () => {
    setOpen1(false);
  };
  const handleUpdatePlan = async () => {

     if (!uploadedFile){
          toast.error("Please upload a file")
          return
        }
    

    try {
      const formData = new FormData();
      formData.append("plan_name", planName);
      formData.append("customer_name", customerName);
      formData.append("plan_description", planDescription);
      // formData.append("category", category);
      //  formData.append("tags", tags);
      if (uploadedFile) {
        formData.append("file", uploadedFile);
      }

      formData.append("plan_id", selectedPlan ? selectedPlan : selectedPlanId);

      const response = await http.put(
        "/master_service/plan_update/records",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {

        toast.success(
          <>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "24px",
                textAlign: "left",
                marginBottom: "8px",
              }}>
              Plan Updated Successfully
            </div>

          </>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
      }
    } catch (error) {
      console.error("Error creating plan:", error);
      toast.error("An error occured");
    } finally {
      setLoading(false);
    }

    setLoading(true);
    try {
      const payload = {
      };
      const response = await http.post("/master_service/feedback/send/data", payload);
      if (response.data.message === "Emails sent successfully") {
        setOpen1(false);
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            Feedback submitted successfully
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
      }
    }
    catch (error) {
      console.error("Error creating account", error);
      toast.error("Error submitting feedback. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const [planListData, setPlanListData] = useState([]);
  // Update the state initialization
  const [selectedPlan, setSelectedPlan] = useState(location.state?.id || "");
  const [planDetails, setPlanDetails] = useState([])

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await http.get("master_service/myplan/details");
      
      if (response.data?.data) {
        const plans = response.data.data.map((plan) => ({
          label: plan.plan_name,
          value: plan.plan_id,
        }));
        setPlanDetails(response.data.data)
        setPlanListData(plans);
        if (location.state?.id) {
          const selectedPlanObj = response.data.data.find(
            (plan) => plan.plan_id === location.state.id
          );
          if (selectedPlanObj) {
            setPlanName(selectedPlanObj.plan_name || "");
            setCustomerName(selectedPlanObj.customer_name || "");
            setPlanDescription(selectedPlanObj.plan_description || "");
          }
        }
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  useEffect(() => {
    if (selectedPlan) {
      fetchReportData(selectedPlan);
    }
  }, [selectedPlan]);

  const [planName, setPlanName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [planDescription, setPlanDescription] = useState("");
  const [category, setCategory] = useState("");
  const [tags, setTags] = useState("");


  const handlePlanChange = (event) => {
    const planId = event.target.value;
    setSelectedPlan(planId);
    const selectedPlanObj = planDetails.find((plan) => plan.plan_id === planId);
    if (selectedPlanObj) {
      setPlanName(selectedPlanObj.plan_name || "");
      setCustomerName(selectedPlanObj.customer_name || "");
      setPlanDescription(selectedPlanObj.plan_description || "");

    }

  };
  const [searchTerm, setSearchTerm] = useState("");

  const filteredPassedData = passedData.filter((row) =>
    Object.values(row).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const filteredFailedData = failedData.filter((row) =>
    Object.values(row).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const groupDataByRuleName = (data) => {
  return data.reduce((acc, row) => {
    if (!acc[row.ruleName]) {
      acc[row.ruleName] = [];
    }
    acc[row.ruleName].push(row);
    return acc;
  }, {});
};

const groupedPassedData = groupDataByRuleName(filteredPassedData);
const groupedFailedData = groupDataByRuleName(filteredFailedData);

const [expandedTables, setExpandedTables] = useState({});

const toggleTableExpansion = (ruleName) => {
  setExpandedTables(prev => ({
    ...prev,
    [ruleName]: !prev[ruleName]
  }));
};
const sortByRuleName = (a, b) => {
  const getNumber = (str) => {
    const match = str[0].match(/Rule-(\d+)/);
    return match ? parseInt(match[1]) : Infinity;
  };
  
  const numA = getNumber(a);
  const numB = getNumber(b);
  
  return numA - numB;
};
const sortByTaskName = (rows) => {
  return [...rows].sort((a, b) => {
    // First try to sort by task ID numerically
    const idA = parseInt(a.taskId);
    const idB = parseInt(b.taskId);
    
    if (!isNaN(idA) && !isNaN(idB)) {
      return idA - idB;
    }
    
    // If task IDs are not available or not numeric, sort by task name
    const getNumber = (str) => {
      const match = str.match(/\d+$/);
      return match ? parseInt(match[0]) : 0;
    };
    
    const baseNameA = a.taskName.replace(/\d+$/, '').trim();
    const baseNameB = b.taskName.replace(/\d+$/, '').trim();
    
    if (baseNameA === baseNameB) {
      return getNumber(a.taskName) - getNumber(b.taskName);
    }
    return baseNameA.localeCompare(baseNameB);
  });
};

  return (
    <div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <ArrowBackIosNewRoundedIcon
            fontSize="small"
            onClick={handleNavigate("/home/analysis")}
          />
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: "21px",
              marginLeft: "8px",
            }}
          >
            Schedule Analysis Report
          </div>
        </div>

        <select
          value={selectedPlan || location.state?.id || ""}
          onChange={handlePlanChange}
          style={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            padding: "5px 60px",
            borderRadius: "4px",
            border: "1px solid lightgray",
            outline: "none",
          }}
        >
          <option value="">Select Plan</option>
          {planListData.map((plan) => (
            <option key={plan.value} value={plan.value}>
              {plan.label}
            </option>
          ))}
        </select>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginTop: "10px",
        }}
      >
       

        <Typography>{selectedPlan 
            ? planListData.find(plan => plan.value === selectedPlan)?.label 
            : location.state?.name || ""}</Typography>

        <div
          style={{
            position: "relative",
            width: "200px",
            marginLeft: "auto",
          }}
        >
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "90%",
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              padding: "8px 2px 8px 20px",
              borderRadius: "4px",
              border: "1px solid lightgray",
              outline: "none",
            }}
          />

        </div>

        <button
          style={{
            padding: "8px 15px",
            fontFamily: "Inter, sans-serif",
            fontSize: "12px",
            fontWeight: 600,
            color: "gray",
            backgroundColor: "#FFF",
            border: "1px solid lightgray",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={handleDownloadReport}
        >
          <img src={Saved} height="10px" width="10px" alt="saved" /> Report
        </button>

        {/* <button
          style={{
            padding: "8px 15px",
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 600,
            color: "white",
            backgroundColor: "#FF2800",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={() => {
            if (selectedPlan) {
              setOpen1(true);
              handleOpen();
            } else {
              toast.error("Please select a plan before updating!");
            }
          }}
        >
          Update Plan
        </button> */}
        <Modal open={open1} onClose={handleClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "600px",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: "8px",
            }}
          >

            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "grey",
              }}
            >
              <img
                src={CloseIcon}
                alt='closeIcon'
                style={{ width: "25px", height: "25px" }}
              />
            </IconButton>
            <Typography style={{ fontSize: "14px", fontWeight: 600, paddingBottom: 5 }} gutterBottom>
              Plan Summary
            </Typography>
            <Typography style={{ fontSize: "12px", fontWeight: 600 }} gutterBottom>
              Plan Name :     {planName}
            </Typography>
            <Typography style={{ fontSize: "12px", fontWeight: 600 }} gutterBottom>
              Customer Name : {customerName}
            </Typography>
            <Typography style={{ fontSize: "12px", fontWeight: 600 }} gutterBottom>
              Plan Description : {planDescription}
            </Typography>
            <Typography style={{ fontSize: "12px", fontWeight: 600 }} gutterBottom>
              Update Plan
            </Typography>
            <FormControl sx={{ height: "100px", width: "100%" }}>
              <div
                {...getRootProps()}
                style={{
                  border: "1px solid lightgray",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "white",
                  cursor: "pointer",
                  borderRadius: "3px",
                }}>
                <input {...getInputProps()} />
                <Box sx={{ textAlign: "center" }}>
                  <FileUploadOutlinedIcon
                    style={{ fontSize: "30px", color: "gray" }}
                  />
                  <Typography
                    variant='body2'
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 500,
                      lineHeight: "20px",
                      color: "gray",
                      marginTop: "5px",
                    }}>
                    Select a file or drag & drop the file
                  </Typography>
                  <Typography
                    variant='body2'
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "20px",
                      textAlign: "center",
                      color: "#0057D5",
                      marginTop: "8px",
                    }}>
                    {uploadedFileName
                      ? `${uploadedFileName} file uploaded successfully`
                      : ""}
                  </Typography>
                </Box>
              </div>
            </FormControl>
            <br />
            <br />

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                onClick={handleClose}
                style={{
                  padding: "8px 14px 8px 14px",
                  marginRight: 8,
                  color: "black",
                  borderColor: "lightgray",
                  borderRadius: "3px",
                  backgroundColor: "white",
                  textTransform: "capitalize",
                  cursor: "pointer"
                }}
              >
                Back
              </Button>
              {/* <Button
                variant="contained"
                style={{
                  padding: "8px 14px 8px 14px",
                  backgroundColor: "#FF2800",
                  color: "white",
                  borderRadius: "3px",
                  textTransform: "capitalize",
                  cursor: "pointer",
                  border: "none"
                }}
                onClick={handleUpdatePlan}
                disabled={loading}>
                {loading ? (
                  <ThreeDot variant='pulsate' color='#FF2800' size='small' />
                ) : (
                  "Update"
                )}
              </Button> */}
            </Box>
          </Box>
        </Modal>
      </div>
      <br />
      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
  <Paper sx={{ 
    p: 2, 
    flex: 1, 
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    borderRadius: '8px'
  }}>
    <Box sx={{ 
      width: 40, 
      height: 40, 
      bgcolor: '#F7F8F8', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      borderRadius: '4px'
    }}>
      <img src={require("../../assets/landing_page/Images/Tick.png")} alt="tasks" width={16} height={16} />
    </Box>
    <Box>
      <Typography sx={{ fontSize: '24px', fontWeight: 600, lineHeight: '32px' }}>
        {totalTask}
      </Typography>
      <Typography sx={{ fontSize: '14px', color: '#6B7280' }}>
        No. of Tasks
      </Typography>
    </Box>
  </Paper>

  {/* Repeat the same structure for other cards */}
  <Paper sx={{ 
    p: 2, 
    flex: 1, 
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    borderRadius: '8px'
  }}>
    <Box sx={{ 
      width: 40, 
      height: 40, 
      bgcolor: '#F7F8F8', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      borderRadius: '4px'
    }}>
      <img src={require("../../assets/landing_page/Images/Time.png")} alt="tests" width={16} height={16} />
    </Box>
    <Box>
      <Typography sx={{ fontSize: '24px', fontWeight: 600, lineHeight: '32px' }}>
        {totalTest}
      </Typography>
      <Typography sx={{ fontSize: '14px', color: '#6B7280' }}>
        No. of Tests Done
      </Typography>
    </Box>
  </Paper>

  <Paper sx={{ 
    p: 2, 
    flex: 1, 
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    borderRadius: '8px'
  }}>
    <Box sx={{ 
      width: 40, 
      height: 40, 
      bgcolor: '#F7F8F8', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      borderRadius: '4px'
    }}>
      <img src={require("../../assets/landing_page/Images/pass.png")} alt="passed" width={20} height={20} />
    </Box>
    <Box>
      <Typography sx={{ fontSize: '24px', fontWeight: 600, lineHeight: '32px', color: '#008000' }}>
        {passedData.length}
      </Typography>
      <Typography sx={{ fontSize: '14px', color: '#6B7280' }}>
        Passed Tasks
      </Typography>
    </Box>
  </Paper>

  <Paper sx={{ 
    p: 2, 
    flex: 1, 
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    borderRadius: '8px'
  }}>
    <Box sx={{ 
      width: 40, 
      height: 40, 
      bgcolor: '#F7F8F8', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      borderRadius: '4px'
    }}>
      <img src={require("../../assets/landing_page/Images/fail.png")} alt="failed" width={20} height={20} />
    </Box>
    <Box>
      <Typography sx={{ fontSize: '24px', fontWeight: 600, lineHeight: '32px', color: '#FF2800' }}>
        {failedTask}
      </Typography>
      <Typography sx={{ fontSize: '14px', color: '#6B7280' }}>
        Failed Tasks
      </Typography>
    </Box>
  </Paper>
</Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
  <Tabs 
    value={activeTab} 
    onChange={handleTabChange}
    TabIndicatorProps={{
      style: {
        backgroundColor: activeTab === 0 ? '#FF2800' : '#008000'
      }
    }}
  >
    <Tab 
            label="Failed Tasks"
            sx={{
              textTransform: "capitalize",
              backgroundColor: activeTab === 0 ? '#FFD4CC' : 'transparent',
              color: activeTab === 0 ? '#FF2800' : '#6B7280',
              '&.Mui-selected': {
                color: '#FF2800',
              }
            }}
          />
    <Tab 
            label="Passed Tasks"
            sx={{
              textTransform: "capitalize",
              backgroundColor: activeTab === 1 ? '#D6F4DE' : 'transparent',
              color: activeTab === 1 ? '#008000' : '#6B7280',
              '&.Mui-selected': {
                color: '#008000',
              }
            }}
          />
  </Tabs>
</Box>

{activeTab === 0 && (
  <div>
    {Object.entries(groupedFailedData)
    .sort(sortByRuleName)
    .map(([ruleName, rows]) => (
      <TableContainer component={Paper} sx={{ mb: 2 }} key={ruleName}>
        <Table>
          <TableHead>
            {/* Parent Row */}
            <TableRow sx={{ backgroundColor: '#F7F8F8' }}>
              <TableCell
                colSpan={columnHeaders.length}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer',
                  padding: '16px',
                  borderBottom: '1px solid #E0E0E0'
                }}
                onClick={() => toggleTableExpansion(ruleName)}
              >
                <Box display="flex" alignItems="center">
                  {ruleName}
                  <Typography
                    sx={{
                      ml: 1,
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px'
                    }}
                  >
                    ({rows.length} Tasks)
                  </Typography>
                </Box>
                {expandedTables[ruleName] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {/* Expandable Nested Table inside the first TableBody */}
            {expandedTables[ruleName] && (
              <TableRow>
                <TableCell colSpan={columnHeaders.length} sx={{ padding: 0 }}>
                  <Table>
                    <TableHead sx={{ backgroundColor: '#FAFAFA' }}>
                      <TableRow>
                        {columnHeaders.map((header, index) => (
                          <TableCell
                            key={index}
                            sx={{
                              borderRight: index < columnHeaders.length - 1 ? "1px solid #E0E0E0" : "none",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <Box display="flex" alignItems="center">
                              <img src={header.icon} alt={header.label} width={16} height={16} style={{ marginRight: "8px" }} />
                              {header.label}
                            </Box>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortByTaskName(rows).map((row, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ borderRight: "1px solid #E0E0E0" }}>{row.taskName}</TableCell>
                          <TableCell sx={{ borderRight: "1px solid #E0E0E0" }}>{row.duration}</TableCell>
                          <TableCell sx={{ borderRight: "1px solid #E0E0E0" }}>{row.startDate}</TableCell>
                          <TableCell sx={{ borderRight: "1px solid #E0E0E0" }}>{row.endDate}</TableCell>
                          <TableCell sx={{ borderRight: "1px solid #E0E0E0" }}>{row.description}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    ))}
  </div>
)}


{activeTab === 1 && (
  <div>
    {Object.entries(groupedPassedData)
    .sort(sortByRuleName)
    .map(([ruleName, rows]) => (
      <TableContainer component={Paper} sx={{ mb: 1 }} key={ruleName}>
        <Table>
          <TableHead>
            {/* Parent Row */}
            <TableRow sx={{ backgroundColor: '#F7F8F8' }}>
              <TableCell
                colSpan={columnHeaders.length}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer',
                  padding: '12px', // Reduced padding
                  borderBottom: '1px solid #E0E0E0'
                }}
                onClick={() => toggleTableExpansion(ruleName)}
              >
                <Box display="flex" alignItems="center">
                  {ruleName}
                  <Typography
                    sx={{
                      ml: 0.5, // Reduced margin
                      padding: '2px 6px', // Smaller padding
                      borderRadius: '4px',
                      fontSize: '12px'
                    }}
                  >
                    ({rows.length} Tasks)
                  </Typography>
                </Box>
                {expandedTables[ruleName] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {/* Expandable Nested Table inside the first TableBody */}
            {expandedTables[ruleName] && (
              <TableRow sx={{ padding: 0 }}> {/* Removed extra padding */}
                <TableCell colSpan={columnHeaders.length} sx={{ padding: 0 }}>
                  <Table>
                    <TableHead sx={{ backgroundColor: '#FAFAFA' }}>
                      <TableRow>
                        {columnHeaders.map((header, index) => (
                          <TableCell
                            key={index}
                            sx={{
                              borderRight: index < columnHeaders.length - 1 ? "1px solid #E0E0E0" : "none",
                              whiteSpace: "nowrap",
                              minWidth: header.label === "Report Description" ? "250px" : // Reduced min-width
                                       header.label === "Task Name" ? "180px" : "130px",
                              padding: "8px", // Reduced padding
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            }}
                          >
                            <Box display="flex" alignItems="center">
                              <img src={header.icon} alt={header.label} width={14} height={14} style={{ marginRight: "6px" }} /> 
                              {header.label}
                            </Box>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortByTaskName(rows).map((row, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ borderRight: "1px solid #E0E0E0", padding: "6px" }}>{row.taskName}</TableCell>
                          <TableCell sx={{ borderRight: "1px solid #E0E0E0", padding: "6px" }}>{row.duration}</TableCell>
                          <TableCell sx={{ borderRight: "1px solid #E0E0E0", padding: "6px" }}>{row.startDate}</TableCell>
                          <TableCell sx={{ borderRight: "1px solid #E0E0E0", padding: "6px" }}>{row.endDate}</TableCell>
                          <TableCell sx={{ borderRight: "1px solid #E0E0E0", padding: "6px" }}>{row.description}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    ))}
  </div>
)}


    </div>

  );
}

export default AnalysisReport;
